import styled, { css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FONT_FAMILY } from 'utils/Constants'
import { layout } from 'styled-system'
import { StripeCardElementOptions } from '@stripe/stripe-js'

export const stripeFontStyles = [
  {
    family: 'Proxima Nova',
    src:
      'url(https://cdn4.careguide.com/assets/ProximaNova/2D6AAD_4_0-6d3c734aad7bccf4444aeaf128e2834ed681037971bfdf3a340ee783965ffbf3.woff) format("woff")',
  },
]

export const stripeInputStyles: StripeCardElementOptions['style'] = {
  base: {
    backgroundColor: '#fff',
    color: '#777779',
    fontSize: '16px',
    fontFamily: FONT_FAMILY.PROXIMA_NOVA,
    // @ts-ignore TODO: types suggest this should be an integer without the `px`.
    padding: '10px',
    '::placeholder': {
      color: 'rgba(119,119,121, 0.5)',
    },
  },
  invalid: {
    color: '#777779',
  },
}

export interface InputStyleProps {
  disabled?: boolean
  isValid?: boolean
}

export const inputStyles = css<InputStyleProps>`
  background-color: #fff;
  border: ${({ isValid, theme }) =>
    isValid ? '1px solid #b2b2b2' : `2px solid ${theme.colors.formErrorColor}`};
  border-radius: 5px;
  box-sizing: border-box;
  color: #777779;
  display: block;
  font-size: 1rem;
  font-family: ${FONT_FAMILY.PROXIMA_NOVA};
  height: 3rem;
  padding: 0 1rem;
  width: 100%;
  transition: all 0.3s ease-out;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: rgba(119, 119, 121, 0.5);
  }
  :-ms-input-placeholder {
    color: rgba(119, 119, 121, 0.5);
  }
  :disabled {
    cursor: not-allowed;
    opacity: 0.75;
  }
  ${layout}
`

export const InputLabel = styled.label`
  display: block;
  position: relative;
  margin-bottom: 1.5rem;
`

export const InputLabelText = styled.span`
  color: ${({ theme }) => theme.colors.textColor};
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
`

export const LoadingSpinner = styled(FontAwesomeIcon)`
  margin-left: 0.5rem;
  position: relative;
  top: -1px;
`

export const LoadingIndicator = styled.span`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  color: #777779;
  position: absolute;
  width: 100%;
  height: 3rem;
  padding: 0 1rem;
`
